import type { SVGProps } from "react";
export interface Link01BreakIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function Link01BreakIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: Link01BreakIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M14.375 22v-2a1.125 1.125 0 0 1 2.25 0v2a1.125 1.125 0 0 1-2.25 0m3.83-3.796a1.125 1.125 0 0 1 1.505-.076l.085.076 1.4 1.4.078.085a1.125 1.125 0 0 1-1.584 1.584l-.084-.078-1.4-1.4-.077-.085a1.125 1.125 0 0 1 .076-1.506ZM22 14.375l.115.006a1.125 1.125 0 0 1 0 2.238l-.115.006h-2a1.125 1.125 0 0 1 0-2.25zm-7.795-6.17a1.125 1.125 0 1 1 1.59 1.59l-6 6a1.125 1.125 0 0 1-1.59-1.59zM4 7.375l.115.005a1.125 1.125 0 0 1 0 2.239L4 9.625H2a1.125 1.125 0 0 1 0-2.25zm-1.196-4.57a1.126 1.126 0 0 1 1.506-.078l.085.077 1.4 1.4.078.086A1.125 1.125 0 0 1 4.29 5.873l-.085-.078-1.4-1.4-.078-.085a1.126 1.126 0 0 1 .077-1.506ZM7.374 4V2a1.125 1.125 0 0 1 2.25 0v2a1.125 1.125 0 0 1-2.25 0"
      />
      <path
        fill={color}
        d="M5.51 10.531a1.125 1.125 0 0 1 1.591 1.59l-1.986 1.987a3.378 3.378 0 0 0 4.777 4.777l1.986-1.986a1.125 1.125 0 1 1 1.591 1.59l-1.986 1.987a5.628 5.628 0 0 1-7.959-7.959zm7.216-7.206a5.628 5.628 0 0 1 7.949 7.949l-.2.21-1.986 1.985a1.125 1.125 0 0 1-1.59-1.59l1.986-1.987.231-.256a3.378 3.378 0 0 0-4.752-4.752l-.256.231-1.985 1.987a1.125 1.125 0 0 1-1.59-1.591l1.984-1.986.21-.2Z"
      />
    </svg>
  );
}
